import api from './api'

export const contactService = {
  // Send contact message
  async sendContactMessage(data, headers = {}) {
    const response = await api.post('/contact/', data, { headers })
    return response.data
  },

  // Get all contact messages (admin)
  async getContactMessages() {
    const response = await api.get('/contact/')
    return response.data
  },

  // Get a specific contact message (admin)
  async getContactMessage(id) {
    const response = await api.get(`/contact/${id}`)
    return response.data
  },

  // Mark message as read (admin)
  async markMessageAsRead(id) {
    const response = await api.put(`/contact/${id}/read`)
    return response.data
  },

  // Delete a contact message (admin)
  async deleteContactMessage(id) {
    const response = await api.delete(`/contact/${id}`)
    return response.data
  }
}
